import { useEffect, useState } from 'react';
import { Modal } from '@mui/material';
import { Box } from '@mui/system';
import Button from '@mui/material/Button';
// import H6 from './H6';
import Subtitle1 from './Subtitle1';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  boxShadow: '0px 0px 4px 1px #383838',
  p: 4,
  borderRadius: '10px',
};

export default function ProdConfirmationDialog({
  openDialog,
  //   message,
  yesHandler,
  data,
}) {
  const [open, setOpen] = useState(false);

  const handleConfirm = () => {
    setOpen(false);
    // eslint-disable-next-line no-param-reassign
    openDialog.show = false;
    if (data) {
      yesHandler(data);
      return;
    }
    yesHandler();
  };

  const handleClose = () => {
    // eslint-disable-next-line no-param-reassign
    openDialog.show = false;
    setOpen(false);
  };

  useEffect(() => {
    setOpen(openDialog.show ? openDialog.show : false);
  }, [openDialog]);

  const env =
    process.env.REACT_APP_ENV === 'production' ? 'PRODUCTION' : 'STAGING';

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        {/* <H6 id="modal-modal-title">
          You are going to update configutation for PROD environment
        </H6> */}
        <Subtitle1
          id="modal-modal-description"
          sx={{ mt: 2 }}>
          {`You are going to add or update configuration for ${env} environment`}
        </Subtitle1>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            columnGap: '5px',
            marginTop: '20px',
          }}>
          <Button
            variant="outlined"
            onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}>
            Confirm
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
